import { Icon } from "@iconify/react";
import OrdersIcon from "../../assets/OrdersIcon";
import FacilitiesIcon from "../../assets/FacilitiesIcon";
import ProfileIcon from "../../assets/ProfileIcon";
import BankDetailsIcon from "../../assets/BankDetailsIcon";
import { MessageIcon } from "../../assets/MessageIcon";
import FinancialsIcon from "../../assets/FinancialsIcon";
import {
  BankIcon,
  ExploreIcon,
  FacilitiesAndServicesIcon,
  FeesIcon,
  MessagesIcon,
  OrderIcon,
  PatientIcon,
  PayoutsIcon,
  ProvidersIcon,
} from "../../assets";

const navlinks = {
  roles: [
    {
      role: "5",
      navigationLinks: [
        {
          id: 1,
          title: "My Profile",
          icon: <ProfileIcon />,
          exact: true,
          url: "/dashboard/profile/",
        },
        {
          id: 2,
          title: "Explore",
          icon: (
            <>
              <Icon icon="material-symbols:explore-outline" />
            </>
          ),
          exact: false,
          url: "/dashboard/",
        },
        // {
        //   id: 2,
        //   title: "Facilities",
        //   icon: (
        //     <>
        //       <Icon icon="icon-park-outline:facial-mask" />
        //     </>
        //   ),
        //   exact: true,
        //   url: "/dashboard/facility"
        // },
        {
          id: 3,
          title: "My Messages",
          icon: <MessageIcon />,
          exact: true,
          url: "/dashboard/messages",
        },

        // {
        //   id: 5,
        //   title: "Patient Profile",
        //   icon: (
        //     <>
        //       <Icon icon="fluent:patient-20-regular" />
        //     </>
        //   ),
        //   exact: true,
        //   url: "/dashboard/patient-profile/"
        // },
        // {
        //   id: 6,
        //   title: "Bank Details",
        //   icon: <BankDetailsIcon/>,
        //   exact: true,
        //   url: "/dashboard/bank-details/"
        // },
        {
          id: 4,
          title: "My Orders",
          icon: <OrdersIcon />,
          exact: true,
          url: "/dashboard/order/",
        },
        {
          id: 8,
          title: "My Patients",
          icon: (
            <>
              <Icon icon="fa-solid:user-injured" />
            </>
          ),
          exact: true,
          url: "/dashboard/patient/",
        },
        {
          id: 9,
          title: "Change Password",
          url: "/dashboard/change-password",
          icon: (
            <>
              <Icon icon="mdi:password-outline" />
            </>
          ),
        },

        {
          id: 10,
          title: "Logout",
          icon: (
            <>
              <Icon icon="solar:logout-outline" />
            </>
          ),
          event: "event",
        },
      ],
    },
    {
      role: "4",
      navigationLinks: [
        {
          id: 1,
          title: "Orders",
          icon: <OrdersIcon />,
          exact: true,
          url: "/dashboard/order/",
        },
        {
          id: 2,
          title: "Facilities and Services",
          icon: <FacilitiesIcon />,
          url: "/dashboard/",
          exact: true,
        },
        {
          id: 3,
          title: "Profile",
          icon: <ProfileIcon />,
          exact: true,
          url: "/dashboard/profile/",
        },
        {
          id: 4,
          title: "Bank Details",
          icon: <BankDetailsIcon />,
          exact: true,
          url: "/dashboard/bank-details/",
        },
        {
          id: 5,
          title: "Messages",
          icon: <MessageIcon />,
          exact: true,
          url: "/dashboard/messages",
        },
        {
          id: 6,
          title: "Financials",
          url: "/dashboard/financials",
          icon: <FinancialsIcon />,
        },
        {
          id: 7,
          title: "Change Password",
          url: "/dashboard/change-password",
          icon: (
            <>
              <Icon icon="mdi:password-outline" />
            </>
          ),
        },
        {
          id: 8,
          title: "Logout",
          icon: (
            <>
              <Icon icon="solar:logout-outline" />
            </>
          ),
          event: "event",
        },
      ],
    },
    {
      role: "3",
      navigationLinks: [
        {
          id: 1,
          title: "My Profile",
          icon: <ProfileIcon />,
          exact: true,
          url: "/dashboard/profile/",
        },
        {
          id: 2,
          title: "Explore",
          icon: (
            <>
              <Icon icon="material-symbols:explore-outline" />
            </>
          ),
          exact: false,
          url: "/dashboard/",
        },
        {
          id: 3,
          title: "Facilities and Services",
          icon: <FacilitiesIcon />,
          url: "/dashboard/facilities",
          exact: true,
        },
        {
          id: 4,
          title: "Orders",
          icon: <OrdersIcon />,
          exact: true,
          url: "/dashboard/order/",
        },

        {
          id: 5,
          title: "Patient",
          icon: (
            <>
              <Icon icon="fa-solid:user-injured" />
            </>
          ),
          exact: true,
          url: "/dashboard/patient/",
        },

        {
          id: 6,
          title: "Fees",
          icon: (
            <>
              <Icon icon="fa-solid:money-bill-wave" />
            </>
          ),
          exact: true,
          url: "/dashboard/fees/",
        },
        {
          id: 7,
          title: "Messages",
          icon: (
            <>
              <Icon icon="lets-icons:chat" />
            </>
          ),
          exact: true,
          url: "/dashboard/messages",
        },
        {
          id: 13,
          title: "User", // New User link
          icon: <Icon icon="mdi:account-group" />,
          exact: true,
          url: "/dashboard/users",
        },
        {
          id: 8,
          title: "Change Password",
          url: "/dashboard/change-password",
          icon: (
            <>
              <Icon icon="mdi:password-outline" />
            </>
          ),
        },
        {
          id: 9,
          title: "Logout",
          icon: (
            <>
              <Icon icon="solar:logout-outline" />
            </>
          ),
          event: "event",
        },
      ],
    },
    {
      role: "2",
      navigationLinks: [
        {
          id: 1,
          title: "My Profile",
          icon: <ProfileIcon />,
          exact: true,
          url: "/dashboard/profile/",
          heading: "",
        },
        {
          id: 2,
          title: "Explore",
          icon: <ExploreIcon />,
          exact: false,
          url: "/dashboard/",
          heading: "",
        },
        {
          id: 3,
          title: "Facilities and Services",
          icon: <FacilitiesAndServicesIcon />,
          url: "/dashboard/facilities",
          exact: true,
          heading: "",
        },
        {
          id: 10,
          title: "Bank Details",
          icon: <BankIcon />,
          exact: true,
          url: "/dashboard/bank-details/",
          heading: "",
        },
        {
          id: 4,
          title: "Orders",
          icon: <OrderIcon />,
          exact: true,
          url: "/dashboard/order/",
          heading: "",
        },

        {
          id: 5,
          title: "Patient",
          icon: <PatientIcon />,
          exact: true,
          url: "/dashboard/patient/",
          heading: "",
        },
        {
          id: 11,
          title: "Payout",
          icon: <PayoutsIcon />,
          exact: true,
          url: "/dashboard/payout/",
          heading: "PAYMENTS",
          submenu: [
            {
              id: 1,
              title: "Payout files",
              url: "/dashboard/payoutfiles/",
              icon: <Icon icon="mdi:map" />, // Optional icon for the submenu item
            },
            {
              id: 2,
              title: "Payout orders",
              url: "/dashboard/payout/orders/",
              icon: <Icon icon="mdi:compass" />, // Optional icon for the submenu item
            },
            {
              id: 3,
              title: "Payout transfers",
              url: "/dashboard/explore/submenu3",
              icon: <Icon icon="mdi:globe" />, // Optional icon for the submenu item
            },
          ],
        },
        {
          id: 6,
          title: "Fees",
          icon: <FeesIcon />,
          exact: true,
          url: "/dashboard/fees/",
          heading: "PAYMENTS",
        },
        {
          id: 12,
          title: "New Providers",
          icon: <ProvidersIcon />,
          exact: true,
          url: "/dashboard/suggestion/",
          heading: "PAYMENTS",
        },
        {
          id: 7,
          title: "Messages",
          icon: <MessagesIcon />,
          exact: true,
          url: "/dashboard/messages",
          heading: "OTHERS",
        },
        {
          id: 8,
          title: "Change Password",
          url: "/dashboard/change-password",
          heading: "OTHERS",
          icon: (
            <>
              <Icon icon="mdi:password-outline" />
            </>
          ),
        },
        {
          id: 13,
          title: "Users", // New User link
          icon: <Icon icon="mdi:account-group" />,
          exact: true,
          url: "/dashboard/users",
        },

        {
          id: 9,
          title: "Logout",
          icon: (
            <>
              <Icon icon="solar:logout-outline" />
            </>
          ),
          event: "event",
          heading: "OTHERS",
        },
      ],
    },
    {
      role: "1",
      navigationLinks: [
        {
          id: 1,
          title: "Facilities and Services",
          icon: <FacilitiesIcon />,
          url: "/dashboard/",
        },
        {
          id: 2,
          title: "User Profile",
          icon: (
            <>
              <Icon icon="radix-icons:avatar" />
            </>
          ),
          url: "/dashboard/profile",
        },
        {
          id: 3,
          title: "Bank Details",
          icon: <BankDetailsIcon />,
          url: "/dashboard/bank-details",
        },
        {
          id: 4,
          title: "Patient Profile",
          icon: (
            <>
              <Icon icon="fluent:patient-20-regular" />
            </>
          ),
          url: "/dashboard/patient-profile",
        },

        {
          id: 5,
          title: "Messages",
          icon: <MessageIcon />,
          url: "/dashboard/messages",
        },
        {
          id: 6,
          title: "Change Password",
          url: "/dashboard/change-password",
          icon: (
            <>
              <Icon icon="mdi:password-outline" />
            </>
          ),
        },
        {
          id: 13,
          title: "User", // New User link
          icon: <Icon icon="mdi:account-group" />,
          exact: true,
          url: "/dashboard/users",
        },

        {
          id: 7,
          title: "Logout",
          icon: (
            <>
              <Icon icon="solar:logout-outline" />
            </>
          ),
          event: "event",
        },
      ],
    },
  ],
};

export { navlinks };
